export default function parseFunnelParams(search) {
  const params = new URLSearchParams(search);
  // `booking-uuid` (tiret) : format historique renvoyé par Tally.
  // `booking_uuid` (underscore) : format renvoyé par l'assistant diagnostic LLM.
  const legacyBookingUuid = params.get('booking-uuid');
  return {
    autodiag: params.get('autodiag'),
    bookingUuid:
      legacyBookingUuid !== null
        ? legacyBookingUuid
        : params.get('booking_uuid'),
  };
}
